import { v4 as uuidv4 } from 'uuid';

export const DEFAULT_SORT_STRATEGY = {
  groupId: uuidv4(),
  sourceIds: [],
  deviceOperatingSystems: ['Android', 'iOS', 'Web'],
  implementationTypes: ['pageoverlay', 'embedonpage', 'none'],
  campaignPlacementSortGroupItems: [
    {
      sortStrategyName: 'random',
      trafficDistribution: 1.0
    }
  ],
  isDefault: true
};

export const SORT_STRATEGY_OPTIONS = [
  { value: 'random', name: 'Random' },
  { value: 'epc', name: 'EPC Sort' },
  { value: 'rpi', name: 'RPI Sort' },
  { value: 'sourceAdgroupScopedPredictiveRPI', name: 'Predictive RPI' },
  {
    value: 'sourcePositionAdgroupScopedPredictiveRPI',
    name: 'Predictive RPI By Position'
  },
  {
    value: 'MlControlledBidCreativeAndSorting',
    name: 'ML Controlled Creative, Bidding, And Sorting'
  }
];

// render nice names for sort strategies based on strategy value
export const SORT_STRATEGY_NAMES = {
  epcSort: 'EPC Sort',
  rpiSort: 'RPI Sort',
  predictiveRpiSort: 'Predictive RPI',
  positionPredictiveRpiSort: 'Predictive RPI By Position',
  random: 'Random',
  MlControlledBidCreativeAndSorting:
    'ML Controlled Creative, Bidding, And Sorting'
};
